import { faCheck, faPlay } from '@fortawesome/free-solid-svg-icons';

import { ModelWarehouseInventoryState } from '@app/api/WarehouseInventories';
import {
  InProgressConditionEnum,
  DefaultConditionEnum,
  SortByEnum,
} from '@app/pages/Warehouses/Inventory/components/InventoryCard/types';
import type { Pagination } from '@app/pages/Warehouses/Inventory/components/InventoryCard/types';

import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import type { MenuProps } from 'antd';
import type { SelectProps } from 'antd/lib';

export const initialPagination: Pagination = {
  pageN: 1,
  itemsPerPage: 20,
  total: 0,
  from: 0,
  to: 0,
};

export const dropdownItems: MenuProps['items'] = [
  {
    key: 'updateProducts',
    label: 'Обновить список товара',
  },
  {
    key: 'editInventory',
    label: 'Редактировать',
  },
];

export const PF = 'inventory-card';

export const STATUS_LABELS: Record<ModelWarehouseInventoryState, string> = {
  [ModelWarehouseInventoryState.Open]: 'В работе',
  [ModelWarehouseInventoryState.Done]: 'Завершена',
};

export const STATUS_ICONS: Record<
  ModelWarehouseInventoryState,
  IconDefinition
> = {
  [ModelWarehouseInventoryState.Open]: faPlay,
  [ModelWarehouseInventoryState.Done]: faCheck,
};

export const IN_PROGRESS_CONDITION_LABELS: Record<
  InProgressConditionEnum,
  string
> = {
  [InProgressConditionEnum.ALL]: 'Все',
  [InProgressConditionEnum.COUNTED]: 'Посчитано',
  [InProgressConditionEnum.NOT_COUNTED]: 'Не учтено',
};

export const DEFAULT_CONDITION_LABELS: Record<DefaultConditionEnum, string> = {
  [DefaultConditionEnum.EXCESS]: 'Избыток',
  [DefaultConditionEnum.DEFICIENCY]: 'Недостаток',
  [DefaultConditionEnum.NORMAL]: 'Норма',
  [DefaultConditionEnum.ALL]: 'Все',
};

export const SORT_OPTIONS: SelectProps['options'] = [
  { value: SortByEnum.NAME, label: 'Название товара' },
  { value: SortByEnum.ALL_COUNT, label: 'Ожидается' },
  { value: SortByEnum.COUNTED, label: 'Посчитано' },
];
